module.exports = __webpack_public_path__ + "assets/images/premium-circle@3x-a5922a0beab52694991ca72e9a8b7c12.png";